import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useParams, useLocation } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute'; // Importer ProtectedRoute
import { isAuthenticated } from './auth';
import CustomerDetails from './CustomerDetails';
import EditCustomer from './EditCustomer';
import NavBar from './NavBar';
import ServiceList from './ServiceList';
import Calculator from './Calculator';
import CustomerList from './CustomerList';
import OrderDetails from './OrderDetails';
import OrderList from './OrderList';
import EmployeeList from './EmployeeList';
import EmployeeChange from './EmployeeChange';
import EmployeeForm from './EmployeeForm';
import CreateOrder from './CreateOrder';
import CreateService from './CreateService';
import SmsTemplateList from './SmsTemplateList';
import SmsTemplateForm from './SmsTemplateForm';
import SmsTemplateChange from './SmsTemplateChange';
import SendSMS from './SendSMS';
import StatusForm from './StatusForm';
import StatusList from './StatusList';
import StatusChange from './StatusChange';
import TodoList from './TodoList';
import ServiceDetailsBike from './ServiceDetailsBike';
import ServiceDetailsSki from './ServiceDetailsSki';
import ServiceDetailsClub from './ServiceDetailsClub';
import ServiceDetailsSkate from './ServiceDetailsSkate';
import TjenesterOgPriser from './pages/tjenester/TjenesterOgPriser';
import TjenesteRediger from './pages/tjenester/TjenesteRediger';
import PartList from './PartList';
import Varelager from './pages/Varelager';
import Kategorier from './pages/Kategorier';
import Lager from './pages/Lager';
import Produkter from './pages/Produkter';
import NettbutikkSalgsrapport from './pages/NettbutikkSalgsrapport';
import SperredePoster from './pages/SperredePoster';
import PartForm from './PartForm';
import PartChange from './PartChange';
import Login from './Login';
import OfferList from './OfferList';
import EditOffer from './EditOffer';
import ClubNet from './ClubNet.js';
import BookingBike from './BookingBike.js';
import BookingDetails from './BookingDetails.js';
import LuckyDrawSetup from "./LuckyDrawSetup";
import LuckyDrawWindow from "./LuckyDrawWindow.js"
import ClubOrderDetails from "./ClubOrderDetails";
import WorkshopList from "./WorkshopList";
import WorkshopDetails from "./WorkshopDetails";
import PublicServicePortal from "./pages/PublicServicePortal";
import CreateEvent from "./CreateEvent.js";
import EventCalendar from "./EventCalendar.js";
import EditEventPage from "./EditEventPage";
import EventStatsPage from "./EventStatsPage";
import WorkshopCapacityStats from "./WorkshopCapacityStats";
import CapacityCheck from "./CapacityCheck";
import AllBikesPage from "./AllBikesPage";
import BikeDetailPage from "./BikeDetailPage";
import ReklamasjonSykkel from "./pages/ReklamasjonSykkel";
import Trykkeguide from "./pages/Trykkeguide";
import TrykkeguideKlubb from "./pages/TrykkeguideKlubb";
import TrykkeguidePrint from "./pages/TrykkeguidePrint";
import Plakater from "./pages/Plakater";
import PlakatMekanikerchat from "./pages/PlakatMekanikerchat";
import PlakatPrislisteSykkel from "./pages/PlakatPrislisteSykkel";
import Avtaler from "./pages/Avtaler";
import AvtaleDetalj from "./pages/AvtaleDetalj";
import Dekkhotell from "./pages/Dekkhotell";
import DekkhotellDetalj from "./pages/DekkhotellDetalj";
import Sykkelhotell from "./pages/Sykkelhotell";
import Hotellkapasitet from "./pages/Hotellkapasitet";
import SykkelhotellDetalj from "./pages/SykkelhotellDetalj";
import Skoyteslip from "./pages/Skoyteslip";
import ServicerPaVerkstedet from "./pages/ServicerPaVerkstedet";
import ServiceInfo from "./pages/ServiceInfo";
import PublicBookingPortal from "./pages/PublicBookingPortal";
import PublicOfferPortal from "./pages/PublicOfferPortal";
import PublicOrderPortal from "./pages/PublicOrderPortal";
import Ordrevarsler from "./pages/Ordrevarsler";
import SykkelTilMinSide from "./pages/SykkelTilMinSide";
import PublicChatPortal from "./pages/PublicChatPortal";
import PublicAkuttPortal from "./pages/PublicAkuttPortal";
import CustomerPortal from "./pages/CustomerPortal";
import MergeCustomers from './MergeCustomers';
import Varsling from "./pages/Varsling";
import ChatHistorikk from "./pages/ChatHistorikk";
import ChatDetalj from "./pages/ChatDetalj";
import AkuttDetalj from "./pages/AkuttDetalj";
import KlubbFakturaimport from "./pages/klubb/Fakturaimport";
import KlubbLager from "./pages/klubb/Lager";
import KlubbTrenere from "./pages/klubb/Trenere";
import KlubbInnkjopsansvarlige from "./pages/klubb/Innkjopsansvarlige";
import KlubbBestillinger from "./pages/klubb/Bestillinger";
import KlubbProdukter from "./pages/klubb/Produkter";
import KlubbRoller from "./pages/klubb/Roller";
import Klubber from "./pages/klubbportal/Klubber";
import KlubbSide from "./pages/klubbportal/KlubbSide";
import UtforBetaling from "./pages/UtforBetaling";
import BetalService from "./pages/BetalService";
import PortalFooter from './components/PortalFooter';
import { erKundeside, kundedomene } from './kundesider';
import NyKundesamhandling from './ny-kundesamhandling/Forside';
import VelgKunde from './ny-kundesamhandling/VelgKunde';


// Butikkdomenene (tilbud.sport1royken.no, tilbud.sport1slemmestad.no) viser bare kundesidene,
// som de andre offentlige portalsidene. Alt annet (ansatt-appen, innloggingen) sendes til
// butikkens nettside (src/kundesider.js, planer/din-side-merker-plan.md M2).
function KundedomeneVakt({ children }) {
    const { pathname } = useLocation();
    const domene = kundedomene();
    const sperret = Boolean(domene) && !erKundeside(pathname);
    useEffect(() => {
        if (sperret) window.location.replace(domene.nettside);
    }, [sperret, domene]);
    if (sperret) {
        return (
            <main id='innhold' className='p-6 text-center text-gray-700'>
                <p>Sender deg til <a href={domene.nettside} className='text-blue-700 underline'>{domene.navn}</a> …</p>
            </main>
        );
    }
    return children;
}

// Videresending fra gamle adresser med :id (pristilbud, fjernet 27.10).
function TilGammelSti({ til }) {
    const { id } = useParams();
    return <Navigate to={`${til}/${id}`} replace />;
}

function App() {
    const [customers, setCustomers] = useState([]);
    const [orders, setOrders] = useState([]);
    const [services, setServices] = useState([]);

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    // Kunder, ordrer og servicer krever innlogging. Hentes derfor først når en
    // ansatt er innlogget, og på nytt når Login.js melder «storeUpdated» etter
    // innlogging — ellers ble listene stående tomme til siden ble lastet på nytt.
    const [authVersion, setAuthVersion] = useState(0);
    useEffect(() => {
        const onLogin = () => setAuthVersion((v) => v + 1);
        window.addEventListener('storeUpdated', onLogin);
        return () => window.removeEventListener('storeUpdated', onLogin);
    }, []);

    useEffect(() => {
        if (!isAuthenticated()) return;
        const fetchCustomers = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/customers`);
                if (response.ok) {
                    const customersData = await response.json();
                    setCustomers(customersData);
                } else {
                    console.error('Feil ved henting av kunder');
                }
            } catch (error) {
                console.error('Feil ved kommunikasjon med serveren:', error);
            }
        };

        fetchCustomers();
    }, [API_BASE_URL, authVersion]);

    useEffect(() => {
        if (!isAuthenticated()) return;
        const fetchOrders = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/orders`);
                if (response.ok) {
                    const ordersData = await response.json();
                    setOrders(ordersData);
                } else {
                    console.error('Feil ved henting av ordrer');
                }
            } catch (error) {
                console.error('Feil ved kommunikasjon med serveren:', error);
            }
        };

        fetchOrders();
    }, [API_BASE_URL, authVersion]);

    useEffect(() => {
        if (!isAuthenticated()) return;
        const fetchServices = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/services`);
                if (response.ok) {
                    const servicesData = await response.json();
                    setServices(servicesData);
                } else {
                    console.error('Feil ved henting av servicer');
                }
            } catch (error) {
                console.error('Feil ved kommunikasjon med serveren:', error);
            }
        };

        fetchServices();
    }, [API_BASE_URL, authVersion]);

    const updateCustomer = (updatedCustomer) => {
        setCustomers((prevCustomers) =>
            prevCustomers.map((customer) =>
                customer.id === updatedCustomer.id ? updatedCustomer : customer
            )
        );
    };

    return (
        <Router>
            <KundedomeneVakt>
            <div>
                <a
                    href='#innhold'
                    className='sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-50 focus:rounded focus:bg-white focus:px-4 focus:py-2 focus:text-blue-800 focus:shadow'
                >
                    Hopp til hovedinnhold
                </a>
                <NavBar />
                <main id='innhold' tabIndex={-1} className='p-2 sm:p-4'>
                    <Routes>
                        <Route path='/login' element={<Login />} />

                        {/* Forsiden: Ny kundesamhandling (erstattet «Søk / Registrer» 26.10). */}
                        <Route path='/' element={<ProtectedRoute element={<NyKundesamhandling />} />} />

                        <Route
                            path='/customer-list'
                            element={
                                <ProtectedRoute
                                    element={
                                        <CustomerList
                                            customers={customers}
                                            deleteCustomer={(id) =>
                                                setCustomers(
                                                    customers.filter(
                                                        (customer) => customer.id !== id
                                                    )
                                                )
                                            }
                                        />
                                    }
                                />
                            }
                        />

                        <Route
                            path='/customer-details/:id'
                            element={
                                <ProtectedRoute
                                    element={<CustomerDetails customers={customers} />}
                                />
                            }
                        />

                        <Route
                            path='/edit-customer/:id'
                            element={
                                <ProtectedRoute
                                    element={
                                        <EditCustomer
                                            customers={customers}
                                            updateCustomer={updateCustomer}
                                        />
                                    }
                                />
                            }
                        />

                        <Route
                            path='/order-details/:id'
                            element={<ProtectedRoute element={<OrderDetails />} />}
                        />
                        <Route path='/ordrevarsler' element={<ProtectedRoute element={<Ordrevarsler />} />} />
                        <Route path='/trykkvarsler' element={<ProtectedRoute element={<Ordrevarsler api="services" />} />} />

                        <Route
                            path='/ordre'
                            element={<ProtectedRoute element={<OrderList orders={orders} />} />}
                        />

                        <Route
                            path='/service'
                            element={
                                <ProtectedRoute element={<ServiceList services={services} />} />
                            }
                        />
                        {/* Gamle sykkel-, ski- og skøyteservicer: fases ut og slettes når de er ryddet opp (vinnsel, 28.10). */}
                        <Route path='/gammel-hardvare' element={<ProtectedRoute element={<ServiceList variant="gamle" />} />} />

                        <Route
                            path='/hjelpemidler'
                            element={<ProtectedRoute element={<Calculator />} />}
                        />


                        {/* Gamle tilbudssider (fjernet 27.10): videre til kundekortet og tilbudet. */}
                        <Route path='/create-offer/:id' element={<TilGammelSti til="/customer-details" />} />

                        <Route
                            path='/sms-template-change/:id'
                            element={<ProtectedRoute element={<SmsTemplateChange />} />}
                        />

                        <Route
                            path='/sms-templates'
                            element={<ProtectedRoute element={<SmsTemplateList />} />}
                        />

                        <Route
                            path='/sms-template-form'
                            element={<ProtectedRoute element={<SmsTemplateForm />} />}
                        />

                        <Route
                            path='/employees'
                            element={<ProtectedRoute element={<EmployeeList />} />}
                        />

                        <Route
                            path='/employee-list'
                            element={<ProtectedRoute element={<EmployeeList />} />}
                        />

                        <Route
                            path='/employee-change/:id'
                            element={<ProtectedRoute element={<EmployeeChange />} />}
                        />

                        <Route
                            path='/employee-form'
                            element={<ProtectedRoute element={<EmployeeForm />} />}
                        />

                        <Route
                            path='/create-order/:customerNumber'
                            element={<ProtectedRoute element={<CreateOrder />} />}
                        />

                        <Route
                            path='/create-service/:customerNumber'
                            element={<ProtectedRoute element={<CreateService />} />}
                        />

                        <Route
                            path='/status-form'
                            element={<ProtectedRoute element={<StatusForm />} />}
                        />

                        <Route
                            path='/status-list'
                            element={<ProtectedRoute element={<StatusList />} />}
                        />

                        <Route
                            path='/status-change/:id'
                            element={<ProtectedRoute element={<StatusChange />} />}
                        />

                        <Route path='/sendsms' element={<ProtectedRoute element={<SendSMS />} />} />

                        <Route path='/todo' element={<ProtectedRoute element={<TodoList />} />} />

                        <Route
                            path='/service-details-bike/:id'
                            element={<ProtectedRoute element={<ServiceDetailsBike />} />}
                        />

                        <Route
                            path='/service-details-ski/:id'
                            element={<ProtectedRoute element={<ServiceDetailsSki />} />}
                        />

                        <Route
                            path='/service-details-skate/:id'
                            element={<ProtectedRoute element={<ServiceDetailsSkate />} />}
                        />

                        <Route
                            path='/service-details-club/:id'
                            element={<ProtectedRoute element={<ServiceDetailsClub />} />}
                        />

                        {/* Fastprislisten er slått sammen med tjenestekatalogen (planer/hygraph-plan.md). */}
                        <Route path='/fixed-price-form' element={<Navigate to='/tjenester/ny' replace />} />
                        <Route path='/fixed-price-list' element={<Navigate to='/tjenester' replace />} />
                        <Route path='/fixed-price-change/:id' element={<Navigate to='/tjenester' replace />} />
                        <Route path='/tjenester' element={<ProtectedRoute element={<TjenesterOgPriser />} />} />
                        <Route path='/tjenester/:id' element={<ProtectedRoute element={<TjenesteRediger />} />} />


                        <Route
                            path='/part-form'
                            element={<ProtectedRoute element={<PartForm />} />}
                        />

                        <Route
                            path='/part-list'
                            element={<ProtectedRoute element={<PartList />} />}
                        />

                        <Route
                            path='/varelager'
                            element={<ProtectedRoute element={<Varelager />} />}
                        />

                        <Route
                            path='/kategorier'
                            element={<ProtectedRoute element={<Kategorier />} />}
                        />

                        <Route
                            path='/lager'
                            element={<ProtectedRoute element={<Lager />} />}
                        />

                        <Route
                            path='/produkter'
                            element={<ProtectedRoute element={<Produkter />} />}
                        />

                        <Route
                            path='/nettbutikk-salgsrapport'
                            element={<ProtectedRoute element={<NettbutikkSalgsrapport />} />}
                        />

                        <Route
                            path='/part-change/:id'
                            element={<ProtectedRoute element={<PartChange />} />}
                        />
                        <Route path="/ny-kundesamhandling" element={<Navigate to="/" replace />} />
                        <Route path="/ny-kundesamhandling/:handlingId" element={<ProtectedRoute element={<VelgKunde customers={customers} addCustomer={(c) => setCustomers((prev) => [...prev, c])} />} />} />
                        <Route path="/workshop" element={<ProtectedRoute element={<WorkshopList />} />} />
                        <Route path="/workshop/:id" element={<ProtectedRoute element={<WorkshopDetails />} />} />
                        <Route path="/offer-list" element={<ProtectedRoute element={<OfferList />} />} />
                        <Route path="/createevent" element={<ProtectedRoute element={<CreateEvent />} />} />
                        <Route path="/eventcalendar" element={<ProtectedRoute element={<EventCalendar />} />} />
                        <Route path="/events/:eventId" element={<ProtectedRoute element={<EditEventPage />} />} />
                        <Route path="/eventstats" element={<ProtectedRoute element={<EventStatsPage />} />} />
                        <Route path="/offer-details/:offerId" element={<ProtectedRoute element={<EditOffer />} />} />
                        <Route path="/varsling" element={<ProtectedRoute element={<Varsling />} />} />
                        <Route path="/chat-historikk" element={<ProtectedRoute element={<ChatHistorikk />} />} />
                        <Route path="/chat-detalj/:id" element={<ProtectedRoute element={<ChatDetalj />} />} />
                        <Route path="/akutt-detalj/:id" element={<ProtectedRoute element={<AkuttDetalj />} />} />
                        <Route path="/offer/:id" element={<TilGammelSti til="/offer-details" />} />
                        <Route path="/bookingbike" element={<ProtectedRoute element={<BookingBike />} />} />
                        <Route path="/booking/:id" element={<ProtectedRoute element={<BookingDetails />} />} />
                        <Route path="/clubnet" element={<ProtectedRoute element={<ClubNet />} />} />
                        <Route path="/ordre/:orderId" element={<ProtectedRoute element={<ClubOrderDetails />} />} />
                        <Route path="/luckydraw" element={<ProtectedRoute element={<LuckyDrawSetup />} />} />
                        <Route path="/luckydrawWindow" element={<ProtectedRoute element={<LuckyDrawWindow />} />} />
                        <Route path="/workshop-statistikk" element={<ProtectedRoute element={<WorkshopCapacityStats />} />} />
                        <Route path="/sjekk-kapasitet" element={<ProtectedRoute element={<CapacityCheck />} />} />
                        <Route path="/regnskap/sperrede" element={<ProtectedRoute element={<SperredePoster />} />} />
                        <Route path="/reklamasjon-sykkel" element={<ProtectedRoute element={<ReklamasjonSykkel />} />} />
                        <Route path="/trykkeguide" element={<ProtectedRoute element={<Trykkeguide />} />} />
                        <Route path="/trykkeguide/:id" element={<ProtectedRoute element={<TrykkeguideKlubb />} />} />
                        <Route path="/trykkeguide/:id/print" element={<ProtectedRoute element={<TrykkeguidePrint />} />} />
                        <Route path="/plakater" element={<ProtectedRoute element={<Plakater />} />} />
                        <Route path="/plakater/mekanikerchat" element={<ProtectedRoute element={<PlakatMekanikerchat />} />} />
                        <Route path="/plakater/prisliste-sykkel" element={<ProtectedRoute element={<PlakatPrislisteSykkel />} />} />
                        <Route path="/avtaler" element={<ProtectedRoute element={<Avtaler />} />} />
                        <Route path="/avtaler/:id" element={<ProtectedRoute element={<AvtaleDetalj />} />} />
                        <Route path="/klubber" element={<ProtectedRoute element={<Klubber />} />} />
                        <Route path="/klubber/:id" element={<ProtectedRoute element={<KlubbSide />} />} />
                        <Route path="/klubb/fakturaimport" element={<ProtectedRoute element={<KlubbFakturaimport />} />} />
                        <Route path="/klubb/lager" element={<ProtectedRoute element={<KlubbLager />} />} />
                        <Route path="/klubb/trenere" element={<ProtectedRoute element={<KlubbTrenere />} />} />
                        <Route path="/klubb/innkjopsansvarlige" element={<ProtectedRoute element={<KlubbInnkjopsansvarlige />} />} />
                        <Route path="/klubb/roller" element={<ProtectedRoute element={<KlubbRoller />} />} />
                        <Route path="/klubb/bestillinger" element={<ProtectedRoute element={<KlubbBestillinger />} />} />
                        <Route path="/klubb/produkter" element={<ProtectedRoute element={<KlubbProdukter />} />} />
                        <Route path="/sykkelkort" element={<ProtectedRoute element={<AllBikesPage />} />} />
                        <Route path="/sykkelkort/:id" element={<ProtectedRoute element={<BikeDetailPage />} />} />
                        <Route path="/dekkhotell" element={<ProtectedRoute element={<Dekkhotell />} />} />
                        <Route path="/dekkhotell/:id" element={<ProtectedRoute element={<DekkhotellDetalj />} />} />
                        <Route path="/sykkelhotell" element={<ProtectedRoute element={<Sykkelhotell />} />} />
                        <Route path="/hotellkapasitet" element={<ProtectedRoute element={<Hotellkapasitet />} />} />
                        <Route path="/sykkelhotell/:id" element={<ProtectedRoute element={<SykkelhotellDetalj />} />} />
                        <Route path="/skoyteslip" element={<ProtectedRoute element={<Skoyteslip />} />} />
                        {/* Forenklet oversikt for butikkansatte; Servicelisten (/workshop) og /workshop/:id er uendret. */}
                        <Route path="/verkstedet" element={<ProtectedRoute element={<ServicerPaVerkstedet />} />} />
                        <Route path="/verkstedet/:id" element={<ProtectedRoute element={<ServiceInfo />} />} />
                        {/* Public route uten navbar */}
                        <Route path="/betal" element={<ProtectedRoute element={<UtforBetaling />} />} />
                        {/* QR-koden på servicelappen. Ikke ProtectedRoute: uinnloggede (kunder)
                            får en side uten data i stedet for innloggingen. Se BetalService.jsx. */}
                        <Route path="/betal/:ref" element={<BetalService />} />
                        <Route path="/svc/:token" element={<PublicServicePortal />} />
                        <Route path="/bookingportal/:token" element={<PublicBookingPortal />} />
                        <Route path="/tilbud/:token" element={<PublicOfferPortal />} />
                        <Route path="/kundeordre/:token" element={<PublicOrderPortal />} />
                        <Route path="/kundetrykk/:token" element={<PublicOrderPortal sti="services" />} />
                        <Route path="/sykkel/:token" element={<SykkelTilMinSide />} />
                        <Route path="/chat/:token" element={<PublicChatPortal />} />
                        <Route path="/akutt/:token" element={<PublicAkuttPortal />} />
                        <Route path="/min-side" element={<CustomerPortal />} />
                        <Route path="/merge-customers/:idA/:idB" element={<ProtectedRoute element={<MergeCustomers />} />} />




                    </Routes>
                </main>
                <PortalFooter />
            </div>
            </KundedomeneVakt>
        </Router>
    );
}

export default App;
